<template>
    <b-row>
        <b-col cols="9">
            <b-row>
                <b-col class="workspace-header">
                    <h1 class="text-right"><i class="fa-duotone fa-clipboard-list-check fa-fw"></i> Kit View</h1>
                </b-col>
            </b-row>

            <b-row v-if="!showTable">
                <b-col>
                    <transition appear name="fade" mode="out-in">
                        <div class="scan-graphic d-flex flex-column justify-content-center align-items-center">
                            <i v-if="scanIsBusy" class="fa-duotone fa-spinner fa-spin fa-10x text-primary"></i>
                            <i v-else-if="scanError" class="fa-duotone fa-circle-exclamation fa-10x text-warning"></i>
                            <i v-else class="fa-duotone fa-scanner fa-10x"></i>
                            <div class="display-4 mt-4 text-muted">Scan Package to Begin</div>
                        </div>
                    </transition>
                </b-col>
            </b-row>

            <b-row v-if="showTable">
                <b-col>
                        <b-card>
                            <b-row>
                                <b-col>
                                    <b-table id="intake-outstanding-results0" ref="intakeOutstandingResults" striped hover borderless
                                            v-if="showTable"
                                            tbody-tr-class="text-center"
                                            head-variant="dark"
                                            primary-key="id"
                                            no-provider-paging
                                            no-provider-sorting
                                            no-provider-filtering
                                            show-empty
                                            :busy.sync="form.isBusy"
                                            :fields="fields"
                                            :items="items">
                                        <template v-slot:head(actions)="data">
                                        </template>
                                        <template v-slot:cell(address)="data">
                                            <div>{{ data.item.address.address1 }}</div>
                                            <div v-if="data.item.address.address2">{{ data.item.address.address2 }}</div>
                                            <div>{{ data.item.address.city }}, {{ data.item.address.state }} {{ data.item.address.zip }}
                                            </div>
                                        </template>
                                        <template v-slot:cell(order_id)="data">
                                            <div>{{ data.item.orders && data.item.orders.data && data.item.orders.data.length ? data.item.orders.data[data.item.orders.data.length-1].id : 'Unknown' }}</div>
                                        </template>
                                        <template v-slot:cell(actions)="data">                        &nbsp;
                                            <b-button @click="gotoOrder" variant="primary"><i
                                                    class="fa-regular fa-cart-plus fa-fw"></i> Goto Order
                                            </b-button>
                                        </template>
                                        <template v-slot:table-busy>
                                            <LoadingSpinner :busy="isBusy"></LoadingSpinner>
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-card>
                </b-col>
            </b-row>
        </b-col>

        <b-col cols="3">
            <b-row>
                <b-col>

                    <CreateNewCustomerModal></CreateNewCustomerModal>

                    <b-button class="float-right" variant="primary" v-b-modal.modal-create-new-order>
                        <i class="fa-solid fa-plus mr-1"></i>Create New Customer with Order
                    </b-button>

                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
    import LoadingSpinner from '@/components/LoadingSpinner';
    import CreateNewCustomerModal from '@/components/CreateNewCustomer';

    export default {
        name: 'kits-view-not-found',
        title: 'Kit View',
        components: {
            CreateNewCustomerModal,
            LoadingSpinner,
        },
        data() {
            return {
                isBusy: false,
                showTable: false,
                chosenCustomerId: null,
                orderId: null,
                modalShow: null,
                modalNewPackageShow: null,
                fields: [
                    {key: 'id', label: 'Customer #', class: 'text-center'},
                    {key: 'order_id', label: 'Order #', class: 'text-center'},
                    {key: 'full_name', label: 'Name', class: 'text-center'},
                    //{key: 'address', label: 'Address', class: 'text-center'},
                    //'actions',
                ],
                items: [],
                form: {
                    name: null,
                    order_id: null,
                    isBusy: false,
                    isOpen: false,
                    isSaving: false,
                    items: [],

                    fields: [
                        {key: 'id', label: 'Customer #', class: 'text-center'},
                        {key: 'order_id', label: 'Order #', class: 'text-center'},
                        {key: 'full_name', label: 'Name', class: 'text-center'},
                        //{key: 'address', label: 'Address', class: 'text-center'},
                        //'actions',
                    ],
                },
                create_new_order: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone: '',
                    address: {
                        address1:'',
                        address2:'',
                        zip: '',
                        city: '',
                        state: null,
                    },
                    label_count: 1,
                    shipping_method: {
                        options: [],
                        value: null
                    },
                    brand: {
                        value: null,
                        options: [],
                    },
                    campaign: {
                        value: null,
                        options: [],
                        option_selected: null,
                    },
                    home_pickup: false,
                },
                scanIsBusy: false,
                scanError: false,
            };
        },
        mounted() {
            this.$barcodeScanner.init((rawBarcode) => {
                this.$barcodeScanner.parseBarcode(rawBarcode, (barcode) => {
                    this.scanIsBusy = true;
                    this.$http.get('/scan/' + encodeURIComponent(barcode)).then((response) => {
                        this.scanIsBusy = false;
                        this.$router.push({path: '/kit/view/' + response.data});
                    })
                        .catch((error) => {
                            if (error.response && error.response.status === 404) {
                                this.scanIsBusy = false;
                                this.scanError = true;
                                setTimeout(() => {
                                    this.scanError = false;
                                }, 2000);
                            }
                        });
                });
            });
        },
        beforeDestroy() {
            this.$barcodeScanner.destroy();
        },
        created() {

        },
        methods: {
            getCustomersBySearch(event) {
                event.preventDefault();
                this.form.isBusy = true;
                this.form.showTable = true;
                this.form.isOpen = true;
                this.$refs.search_input_popover.$emit('open');
                setTimeout(()=>{this.form.isOpen = true; this.$refs.search_input_popover.$emit('open');}, 30);
                this.$http.get('/search/customers', {
                    params: {
                        q: this.form.name
                    }
                })
                    .then(response => {
                        this.form.items = response.data.data;
                        for(var i = 0; i <  this.form.items.length; i++)
                        {
                            var orders = this.form.items[i].orders.data;
                            this.form.items[i].latest_order = orders.length == 0 ? null : orders[orders.length - 1];
                        }
                        this.form.isBusy = false;
                    });
            },
            gotoOrder(customer){
                if(customer.orders && customer.orders.data && customer.orders.data.length != 0) {
                    let order = customer.orders.data[customer.orders.data.length - 1];
                    this.$router.replace({
                        path: '/kit/view/' + order.id,
                    });
                }
            },
            confirmCreateOrderForCustomer(id) {
                this.chosenCustomerId = id;
                this.modalShow = true;
            },
            confirmCreatePackagingForExisting(id,order_id){
                this.chosenCustomerId = id;
                this.orderId = order_id;
                this.modalNewPackageShow = true;
            },
            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault();
                this.createOrderForCustomer();
            },
            handleOKAddPackage(bvModalEvt) {
                bvModalEvt.preventDefault();
                this.addTrackingToOrder();
            },
        }
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

</style>

<style scoped>
    .scan-graphic i {
        font-size: 18rem;
        color: gray;
    }

    .scan-graphic {
        height: 75vh;
    }
</style>
